import React from 'react'
import styled from 'styled-components';
import ReactAudioPlayer from "react-audio-player";
import { Row,Col, Container } from 'react-bootstrap';
import Avatar from "../../../../assets/pngs/Avatar.png" 
import Audio from "../../../../assets/audio/Try it hard.mp3";
import ProfilePhoto1st2911 from '../../../../components/ProfilePhoto1st2911';
import TextS1st2911 from '../../../../components/text/TextS1st2911';
import { DeviceDetails } from './DeviceDetails';
import { ProfilePicStyle, FstNameStyle, headlineStyle, subTextStyle } from '../../../../Styles/styledComponents/sidebar';

 const VictimDetails = () => {
  return (
<>
   <VictimDiv>
    <ProfilePhoto1st2911  data={{source:Avatar,customStyle: ProfilePicStyle,}}/>
    <Container>
    <Row>
    <Col className='d-flex justify-content-start'>
    <TextS1st2911 data={{text:'Lamiaa',customStyle:FstNameStyle}}/>
    <TextS1st2911 data={{text:'Moustafa'}}/>
    </Col>
    <Col className='d-flex justify-content-start'>
    <TextS1st2911 data={{text:'Speed:',customStyle:headlineStyle}}/>
    <TextS1st2911 data={{ text: "MPH" }} />
    </Col>
    </Row>
    </Container>
   </VictimDiv>
   <Col>
      <TextS1st2911
        data={{ text: "LIVE AUDIO:", customStyle: headlineStyle }}
      />
      <ReactAudioPlayer src={Audio} controls />
      <TextS1st2911
        data={{ text: "Time of incident", customStyle: headlineStyle }}
      />
      <TextS1st2911
        data={{ text: "Address", customStyle: headlineStyle }}
      />
       <TextS1st2911
        data={{ text: "Addtional Info", customStyle: headlineStyle }}
      />
      <TextS1st2911
        data={{ text: "Age:", customStyle: subTextStyle}}
      />
       <TextS1st2911
        data={{ text: "Gender:", customStyle: subTextStyle }}
      />
       <TextS1st2911
        data={{ text: "Height:", customStyle: subTextStyle }}
      />
       <TextS1st2911
        data={{ text: "Weight:", customStyle: subTextStyle }}
      />
       <TextS1st2911
        data={{ text: "Hair Color:", customStyle: subTextStyle }}
      />
       <TextS1st2911
        data={{ text: "Eye Color:", customStyle: subTextStyle }}
      />
       <TextS1st2911
        data={{ text: "Add'nlt:", customStyle: subTextStyle}}
      />
      </Col>
      <DeviceDetails/>
      </>
      
  )
}
export default VictimDetails;

const VictimDiv = styled.div`
width:100%;
    display:flex;
    align-items:center;
    justify-content:flex-start;
    padding:10px;
`

